(function (window) {
  'use strict';

  var FASESPANNING = 230;
  var LIJNSPANNING = 400;
  var KLASSEN = [16, 32];
  var MARGE_KW = 0.05;

  function getal(x) {
    var n = parseFloat(x);
    return n > 0 ? n : null;
  }

  function stroom(auto) {
    if (!auto) return null;
    var spec = getal(auto.stroom);
    if (spec) return spec;
    var kw = getal(auto.kw);
    var fasen = parseInt(auto.fasen, 10);
    if (!kw) return null;
    if (fasen === 1) return (kw * 1000) / FASESPANNING;
    if (fasen === 2) return (kw * 1000) / (2 * FASESPANNING);
    if (fasen === 3) return (kw * 1000) / (Math.sqrt(3) * LIJNSPANNING);
    return null;
  }

  function klasse(auto) {
    var s = stroom(auto);
    if (s === null) return null;
    var nodig = Math.round(s);
    for (var i = 0; i < KLASSEN.length; i++) {
      if (nodig <= KLASSEN[i]) return KLASSEN[i];
    }
    return null;
  }

  function isType1(aansluiting) {
    return /type\s*1/i.test(String(aansluiting || ''));
  }

  function levert(auto, kabelFasen, kabelAmpere) {
    var kw = getal(auto && auto.kw);
    var autoFasen = parseInt(auto && auto.fasen, 10);
    var nodig = stroom(auto);
    if (!kw || !autoFasen || nodig === null) return null;
    var fasenUit = Math.min(autoFasen, kabelFasen);
    if (fasenUit >= autoFasen && Math.round(nodig) <= kabelAmpere) return kw;
    return Math.min((fasenUit * Math.min(nodig, kabelAmpere) * FASESPANNING) / 1000, kw);
  }

  function beste(auto, kabels, negeerAansluiting) {
    var winnaar = null;
    (kabels || []).forEach(function (k) {
      if (!negeerAansluiting && auto.aansluiting && k.aansluiting &&
          auto.aansluiting !== k.aansluiting) return;
      var uit = levert(auto, k.fasen, k.ampere);
      if (uit === null) return;
      if (!winnaar) { winnaar = { kabel: k, levert: uit }; return; }
      if (uit > winnaar.levert + MARGE_KW) { winnaar = { kabel: k, levert: uit }; return; }
      if (Math.abs(uit - winnaar.levert) <= MARGE_KW && k.kw < winnaar.kabel.kw) {
        winnaar = { kabel: k, levert: uit };
      }
    });
    return winnaar;
  }

  function alsModel(v, m, onbekend) {
    var uit = {};
    Object.keys(v).forEach(function (k) { uit[k] = v[k]; });
    uit.naam = m.naam;
    uit.volnaam = m.volnaam || m.naam;
    uit.url = m.url;
    if (onbekend) uit.onbekend = true;
    return uit;
  }

  function analyseerModel(m) {
    var vs = m && m.varianten ? m.varianten : [];
    if (!vs.length) return { auto: m || null, vraag: false, veilig: !!m };

    var aansluitingen = {};
    var klassen = {};
    var compleet = true;
    var sterkste = null;
    var sterksteStroom = -1;

    vs.forEach(function (v) {
      var k = klasse(v);
      if (k === null || !v.aansluiting) compleet = false;
      if (k !== null) klassen[k] = true;
      if (v.aansluiting) aansluitingen[v.aansluiting] = true;
      var s = stroom(v);
      if (s !== null && s > sterksteStroom) {
        sterkste = v;
        sterksteStroom = s;
      }
    });

    var soorten = Object.keys(aansluitingen);
    var veilig = compleet && sterkste !== null && soorten.length === 1 && !isType1(soorten[0]);

    if (veilig && Object.keys(klassen).length === 1) {
      return { auto: alsModel(sterkste, m, false), vraag: false, veilig: true };
    }
    return {
      auto: veilig ? alsModel(sterkste, m, true) : null,
      vraag: true,
      veilig: veilig
    };
  }

  function autoVoor(m, analyse, keuze) {
    if (!analyse.vraag) return analyse.auto;
    if (keuze === '?') return analyse.veilig ? analyse.auto : null;
    var v = m.varianten[parseInt(keuze, 10)];
    return v ? alsModel(v, m, false) : null;
  }

  function modelLabel(m) {
    return m.naam;
  }

  function uitvoeringVeld(wrap) {
    var kies = wrap && wrap.querySelector('[data-uitvoering-kies]');
    if (!kies) return null;
    var hulp = wrap.querySelector('[data-uitvoering-hulp]');

    function optie(waarde, tekst) {
      var o = document.createElement('option');
      o.value = waarde;
      o.textContent = tekst;
      kies.appendChild(o);
    }

    return {
      select: kies,
      verberg: function () {
        wrap.hidden = true;
        kies.innerHTML = '';
        if (hulp) hulp.textContent = '';
      },
      toon: function (m, analyse) {
        kies.innerHTML = '';
        if (analyse.veilig) optie('?', wrap.dataset.tekstOnbekend || '');
        else optie('', wrap.dataset.tekstKies || '');
        (m.varianten || []).forEach(function (v, i) { optie(String(i), v.naam); });
        kies.value = analyse.veilig ? '?' : '';
        if (hulp) hulp.textContent = (analyse.veilig ? wrap.dataset.tekstVeilig : wrap.dataset.tekstOnveilig) || '';
        wrap.hidden = false;
      }
    };
  }

  window.VTKabel = {
    stroom: stroom,
    klasse: klasse,
    isType1: isType1,
    levert: levert,
    beste: beste,
    analyseerModel: analyseerModel,
    autoVoor: autoVoor,
    modelLabel: modelLabel,
    uitvoeringVeld: uitvoeringVeld
  };
})(window);
